import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledHeader = styled.h3`
  display: flex;
  justify-content: center;
  margin-bottom: ${CssSpace.SPACE_4};
`;
